var helperClasses = {
    init: function() {
        this.childSameHeight();
        this.stickInParent();
        this.selectric();
        this.scrollTo();
    },

    childSameHeight: function() {
        $('.childSameHeight').each(function() {
            var $this = $(this);

            var targetSelector = $this.data('target');

            var $target = (targetSelector && $this.find(targetSelector)) || $this.children();

            $target.matchHeight();
        });
    },

    stickInParent: function() {
        var $stickInParent = $('.stickInParent');

        $stickInParent.each(function() {
            var $this = $(this),
                offset_top = 60; // needs to be height of nav

            var offset = $this.data('offset') || 0;

            $this.stick_in_parent({
                offset_top: offset_top + Number(offset)
            });
        });
    },

    selectric: function() {
        $('select.selectric').selectric({
            arrowButtonMarkup: '<div class="button icon icon-arrow-down-purple"></div>'
        });
    },

    scrollTo: function() {
        $('a[href*="#"]:not([href="#"])').click(function(e) {
            // On-page links
            if (
                location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') &&
                location.hostname === this.hostname
            ) {
                // Figure out element to scroll to
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    e.preventDefault();

                    $('html, body').animate(
                        {
                            scrollTop: target.offset().top - 60
                        },
                        300
                    );
                }
            }
        });
    }
};
